'use strict';
const mmWidgets = require('../widgets/mm-widgets');
mmWidgets.fn.nodeLineColorWidget = function (mapEditorModel, colorPickerModel) {
	return mmWidgets.each(this, function () {
		const element = this;
		element.click(function () {
			if (mapEditorModel.isEditingEnabled()) {
				colorPickerModel.pickColor().then(function (color) {
					mapEditorModel.updateLineProperty('color', color);
				});
			}
		});
	});
};
